/**
 * src/components/publico/FormularioCuenta.jsx
 * Los tres campos del alta. Solo pinta y valida en el navegador; quién crea la
 * cuenta y a dónde va después lo decide quien lo use.
 *
 * Está separado a propósito: el día que el alta empiece por el RUT (enseñar la
 * empresa detectada ANTES de pedir la contraseña), ese paso nuevo se pone
 * delante y este componente se reutiliza tal cual. Ver la nota de Register.jsx.
 */
import { useState } from 'react'
import { Aviso, Campo } from './Campo'
import { BotonPrincipal } from './BotonPrincipal'

const MIN_PASSWORD = 8

export function FormularioCuenta({ onEnviar, cargando, error, textoBoton, textoCargando }) {
  const [form, setForm] = useState({ nombre: '', email: '', password: '' })
  const [errorLocal, setErrorLocal] = useState('')

  function set(campo) {
    return e => {
      const v = e.target.value
      setForm(f => ({ ...f, [campo]: v }))
      if (errorLocal) setErrorLocal('')
    }
  }

  function enviar(e) {
    e.preventDefault()
    if (!form.nombre.trim() || !form.email.trim() || !form.password) {
      setErrorLocal('Completa los tres campos para continuar.')
      return
    }
    if (form.password.length < MIN_PASSWORD) {
      setErrorLocal(`La contraseña necesita al menos ${MIN_PASSWORD} caracteres.`)
      return
    }
    onEnviar({ nombre: form.nombre.trim(), email: form.email.trim(), password: form.password })
  }

  return (
    <form onSubmit={enviar} style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
      <Campo etiqueta="Nombre" name="name" autoComplete="name" placeholder="Tu nombre"
             valor={form.nombre} onChange={set('nombre')} disabled={cargando} autoFocus />

      <Campo etiqueta="Email de trabajo" tipo="email" name="email" autoComplete="email"
             placeholder="tu@empresa.cl" valor={form.email} onChange={set('email')}
             disabled={cargando} />

      <Campo etiqueta="Contraseña" tipo="password" name="new-password"
             autoComplete="new-password" placeholder={`Mínimo ${MIN_PASSWORD} caracteres`}
             valor={form.password} onChange={set('password')} disabled={cargando} />

      <Aviso>{errorLocal || error}</Aviso>

      <BotonPrincipal type="submit" cargando={cargando} textoCargando={textoCargando}>
        {textoBoton}
      </BotonPrincipal>
    </form>
  )
}
